import { CloseSmall } from '@icon-park/react';
import { memo } from 'react';
import { type ClearIndicatorProps, components, type GroupBase } from 'react-select';

export const ClearIndicatorBase = <
  TOption,
  TIsMulti extends boolean,
  TGroup extends GroupBase<TOption>,
>(
  props: ClearIndicatorProps<TOption, TIsMulti, TGroup>,
) => (
  <components.ClearIndicator {...props}>
    <CloseSmall />
  </components.ClearIndicator>
);

ClearIndicatorBase.displayName = 'ClearIndicator';

export default memo(ClearIndicatorBase);
